export default {
  name: "ProvisionsNotMetDialog",
  props: {
    provisions: {
      type: Array,
      required: true
    }
  },
  mixins: [],
  created() {
    this.show = true;
  },
  computed: {
    metProvisions: function() {
      return this.provisions.filter(provision => provision.met);
    }
  },
  methods: {
    onPrimary() {
      this.close();
    },
    onClickOutside() {
      this.close();
    },
    close() {
      this.$emit("onPrimary");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/ProvisionsNotMetDialog.js